<template>
	<v-card
		dense
	>
		<v-card-text>
			<v-row>
				<v-col class="s-col-form">
					<s-select-definition
						label="Categoría"
						:def="1438"
					></s-select-definition>
				</v-col>
				<v-col class="s-col-form">
					<s-text
						label="Precio"
						decimal
					></s-text>
				</v-col>
				<v-col
					v-if="typeCultiveSelect == 3"
					class="s-col-form"
				>
					<s-text
						label="Objetivo"
					></s-text>
				</v-col>
				<v-col
					v-if="typeCultiveSelect == 3"
					class="s-col-form"
				>
					<s-text
						label="% Mínimo"
					></s-text>
				</v-col>
				<v-col
					v-if="typeCultiveSelect == 3"
					class="s-col-form"
				>
					<s-text
						label="% Máximo"
					></s-text>
				</v-col>
			</v-row>
		</v-card-text>
	</v-card>
</template>

<script>
	export default {
		props: {
			rowSelect: {},
		},

		data() {
			return {
				typeCultiveSelect : 0,
			}
		},

		created () {
			this.typeCultiveSelect = this.rowSelect.TypeCultive;
		},
	}
</script>

<style scoped>

</style>